<div class="row align-center">
    <img
        routerLink="/home/user"
        src="/logo.svg"
        alt="ideastream.io Logo mit Text"
        class="logo pointer"
    />
    <div class="col">
        <h4 class="strong usertrackname">
            {{ trackName }}
        </h4>
        <div class="companyname uppercase">
            {{ trackType }}
        </div>
    </div>
</div>
<div class="row gap-8 align-center">
    <div class="row gap-8 align-center">
        <rr-teamheader></rr-teamheader>
    </div>
    <rr-usermenue [showName]="false"></rr-usermenue>
</div>
